import { useCallback } from 'react';
import { useAppDownloadModal } from './useAppDownloadModal';
import { bridge } from '../utils/bridge/bridge';
import { convertDeeplinkToWebLink } from '../utils/convertDeeplinkToWebLink/convertDeeplinkToWebLink';

export const useOpenDeeplink = () => {
  const { show: showAppDownloadModal } = useAppDownloadModal();

  const openDeeplink = useCallback(
    (link: string) => {
      bridge.openDeeplink(link, {
        webCallback: async () => {
          const webLink = await convertDeeplinkToWebLink(link);
          if (webLink == null) {
            showAppDownloadModal();
            return;
          }
          location.href = webLink;
        },
      });
    },
    [showAppDownloadModal],
  );

  return { openDeeplink };
};
